import { createBooleanDevicePreference } from './devicePreference';

// Per-device toggle for in-app hints (the tap-tooltips on column headers,
// the Fail explanation bubble, and any future HeaderTooltip reuse). Default
// ON so a new install (and the family's reduced-vision users) get the
// explanations until they opt out. Now a thin instance of the shared
// devicePreference factory (AP-0d consolidation) — key and semantics
// unchanged.
const pref = createBooleanDevicePreference('jackedlogs.hints.v1.enabled', true);

export const useHintsEnabled = pref.usePreference;
